import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { ErrorResponse } from "../../../requests/@types";
import { InterestingStringsResponse } from "../@types";
import api from "../api";

export const SAMPLE_REPORT_INTERESTING_STRINGS_KEY =
  "sampleReportInterestingStrings";

const getQueryFn = (hash: string, sourceId: number, relationshipId?: number) =>
  api.getSampleReportInterestingStrings(hash, sourceId, relationshipId);

const getQueryKey = (
  hash?: string,
  sourceId?: number,
  relationshipId?: number
) => [SAMPLE_REPORT_INTERESTING_STRINGS_KEY, hash, sourceId, relationshipId];

const useGetInterestingStrings = (
  hash: string,
  sourceId: number,
  relationshipId?: number
) => {
  const { isLoading, isFetched, data } = useQuery<
    AxiosResponse<InterestingStringsResponse>,
    ErrorResponse,
    InterestingStringsResponse
  >({
    queryFn: () => getQueryFn(hash, sourceId, relationshipId),
    queryKey: getQueryKey(hash, sourceId, relationshipId),
    select: ({ data: responseData }) => responseData,
    enabled: Boolean(hash && sourceId)
  });

  return { isLoading, isFetched, data };
};

export default useGetInterestingStrings;
